import React from 'react';
import { MAX_FILE_SIZE } from '../../utils/constants';
import { getText } from '../../utils/functions';
import { useIcons } from '../../utils/hooks';
import { ValidationContext } from '../validation/ValidationProvider';
import ValidationWrapper from '../validation/ValidationWrapper';

/* THIS COMPONENT LACKS LABEL, IT ONLY IMPLEMENTS THE **INPUT**  */

/**
 * Constant values for complex styling props
 */
const defaultClassName = {
	classNameDIV: 'relative flex flex-col w-full rounded-sm',
	classNameBTN: 'px-5 py-3 focus:outline-none font-bold rounded-lg',
	classNameTXT: 'text-sm md:text-base',
	classNameFILE: 'flex w-full p-2 space-x-4 cursor-default items-center',
	classNameIMG: 'self-center cursor-pointer mt-1',
	classNameDocumentTitle: 'w-full overflow-ellipsis overflow-hidden whitespace-nowrap',
	classNameFileSize: 'w-max text-right',
};

function FileInput({
	portal,
	name,
	label,
	text,
	value,
	onChange = () => {},
	totalAttachmentsSize = 0,
	translate,
	colors,
	required = true,
	checkbbdd,

	/* OPTIONAL PROPS */
	id,
	maxSize = MAX_FILE_SIZE,
	fillMode = false,
	acceptedFileTypes,
	style,
	styleWRAPPER,
	className,
}) {
	/* Variable that checks if any point of the component is being hovered so style can be applied to the Box */
	const [hover, setHover] = React.useState(false);
	const { Document } = useIcons(colors);

	/* Variable that calculate de file size in MB */
	const fileSizeMB = `${(value?.filesize / 1024 / 1024).toFixed(3)}MB`;

	/* Validation context */
	const {
		showValidation
	} = React.useContext(ValidationContext);

	/* Icon hook */
	const { Cross } = useIcons(colors);

	const defaultStyleDesactivated = {
		color: colors?.deactivated,
	};

	/* Default values for the styles */
	const defaultStyle = {
		border: `1px solid ${colors?.primary}`,
		backgroundColor: hover ? colors?.light : colors?.background,
		color: colors?.text,
		transition: 'all 100ms ease-in',
	};
	const defaultFillStyle = {
		backgroundColor: hover ? colors?.light : colors?.primary,
		color: hover ? colors?.primary : colors?.secondary,
		outline: hover && `1px solid ${colors?.primary}`,
		transition: 'all 100ms ease-in',
	};
	const defaultStyleWRAPPER = {
		borderBottom: null,
	};
	const defaultStyleRequired = {
		color: colors?.text,
		backgroundColor: colors?.light,
		transition: 'all 300ms ease-in'
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideClassName = { ...defaultClassName, ...className };
	const overrideStyle = { ...(fillMode ? defaultFillStyle : defaultStyle), ...style };
	const overrideStyleWRAPPER = { ...defaultStyleWRAPPER, ...styleWRAPPER };

	/* Mouseover Styling */
	const onMouseOver = () => setHover(true);
	const onMouseLeave = () => setHover(false);

	/* Prepare and transform file to the necessary format */
	const addFile = async event => {
		event.preventDefault();
		const file = event.nativeEvent.target.files[0];

		// If there is no file
		if (!file) {
			return;
		}

		if ((file.size + totalAttachmentsSize) / 1000 > maxSize) {
			// setState({
			//  ...state,
			//  alert: true
			// });
			return;
		}

		if (!acceptedFileTypes.includes(file.type)) {
			// setState({
			//  ...state,
			//  alert: true
			// });
			return;
		}

		const reader = new FileReader();
		reader.readAsBinaryString(file);
		reader.onload = async ev => {
			// setState({
			//  ...state,
			//  alert: false
			// });
			const fileInfo = {
				filename: name,
				name: file.name,
				filetype: file.type,
				filesize: ev.loaded,
				base64: btoa(reader.result)
			};
			if (reader.readyState === 2) {
				onChange(name, fileInfo, text);
				event.target.value = '';
			}
		};
	};

	/* Obtaining extensions from acceptedFileTypes */
	const arraySplit = acceptedFileTypes.split(',');
	const extensions = [];
	let typeExtensions = '';

	arraySplit.forEach(element => {
		const index = element.indexOf('/');
		extensions.push(element.substr(index + 1, element.length - 1));
	});
	typeExtensions = extensions.join(', ');
	typeExtensions = `${typeExtensions}. `;

	/* Concatenation attachments texts */
	const valueMaxSize = `${maxSize / 1000}MB`;
	const textExtensions = getText(portal?.config?.forms?.attachmentsTextExtensions, translate)?.replace('{typeExtensions}', typeExtensions);
	const textFileSize = getText(portal?.config?.forms?.attachmentsTextFileSize, translate)?.replace('{valueMaxSize}', valueMaxSize);


	/* Hidden input for native input handling and better styling */
	const hiddenFileInput = React.createRef(null);

	/* When the button is clicked, activate the input's onClick event */
	const handleClick = () => {
		hiddenFileInput.current.click();
	};

	return <div id={id} className={overrideClassName.classNameDIV}>
		<ValidationWrapper
			value={value}
			name={name}
			required={required}
			checkbbdd={checkbbdd}
			colors={colors}
			styleDIV={overrideStyleWRAPPER}
			classNameERRORBOTTOM = 'text-xs md:text-sm absolute w-full block top-10 cursor-default'
			keepEmptySpace={false}
		>
			{/* Double div wrapping to keep the display in column mode */}
			<div className={overrideClassName.classNameDIV}>
				{/* MAIN BUTTON */}
				<button
					className={overrideClassName.classNameBTN}
					onClick={handleClick}
					style={overrideStyle}
					onMouseOver={onMouseOver}
					onMouseLeave={onMouseLeave}
					type = "button"
				>
					<span className={overrideClassName.classNameTXT}>
						{`${label}${required ? '*' : ''}`}
					</span>
				</button>
				{!showValidation && <span className='text-xs mt-2' style={defaultStyleDesactivated}>{textExtensions}{textFileSize}</span>}
				{required && hover
					&& <label
						className={'absolute z-50 top-14 ml-0.5 p-1 text-xs md:text-sm'}
						style={defaultStyleRequired}
					>
						{translate.field_required}
					</label>}
				{/* HIDDEN INPUT allows to access native file explorer */}
				<input
					type="file"
					ref={hiddenFileInput}
					onChange={addFile}
					accept={acceptedFileTypes}
					className='hidden' />
				{/* FILE LABEL */}
				{value
					&& <div className={overrideClassName.classNameFILE}>
						<div>
							{Document && Document({})}
						</div>
						<div className={overrideClassName.classNameDocumentTitle}>
							<span>
								{value.name}
							</span>
						</div>
						<div className={overrideClassName.classNameFileSize}>
							<span
								style={defaultStyleDesactivated}
							>
								{fileSizeMB}
							</span>
						</div>
						<div onClick={() => onChange(name, null, text)}>
							{Cross && Cross({
								className: overrideClassName.classNameIMG
							})}
						</div>
					</div>
				}
			</div>
		</ValidationWrapper>
	</div>;
}

export default FileInput;
